import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Loader as GuiLoader } from '@figure/frontlib-gui';

const Wrapper = styled.div`
  display: ${({ isFetching }) => (isFetching ? 'block' : 'none')};
`;

const Loader = ({ isFetching, message }) => (
  <Wrapper isFetching={isFetching} data-test-id="global-loader">
    <GuiLoader message={message} />
  </Wrapper>
);

Loader.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

Loader.defaultProps = {
  message: '',
};

export default Loader;
